import TableSearchFilter from 'components/UIComponents/TableSearchFilter'
import {
  MenuFlex,
  StyledTab,
  SubmitFlex,
} from 'modules/Roles/ViewRole/CollegesTable/CollegeFilter/Styles/style'
import React, { useState } from 'react'

import Button from 'components/Button'
import CandidateRangeFilter from 'modules/Roles/ViewRole/CollegesTable/CollegeFilter/Partials/CandidateRangeFilter'
import CollegeTierFilter from 'modules/Roles/ViewRole/CollegesTable/CollegeFilter/Partials/CollegeTierFilter'
import DriveStatusFilter from 'modules/Roles/ViewRole/CollegesTable/CollegeFilter/Partials/DriveStatusFilter'
import JDFilter from 'modules/Roles/ViewRole/CollegesTable/CollegeFilter/Partials/JDFilter'
import LocationFilter from 'modules/Roles/ViewRole/CollegesTable/CollegeFilter/Partials/LocationFilter'

const CollegeFilter = ({
  appliedCollegesList,
  collegesFilterData,
  setCollegesFilterData,
  locationValue,
  setLocationValue,
  collegeRankValue,
  setCollegeRankValue,
  collegeTierValue,
  setCollegeTierValue,
  driveStatusValue,
  setDriveStatusValue,
  candidateRangeMin,
  setCandidateRangeMin,
  candidateRangeMax,
  setCandidateRangeMax,
  searchValue,
  setSearchValue,
  singleRoleData,
  jdValue,
  setJDValue,
  cityRoleData,
  loadMore,
  locationSearch,
  setLocationSearch,
  cityData,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const submitFilter = () => {
    setCollegesFilterData({
      location: locationValue[0] || '',
      rankingStart: collegeRankValue?.start || '',
      rankingEnd: collegeRankValue?.end || '',
      tiers: Number(collegeTierValue[0]) || '',
      candidateStart: candidateRangeMin || '',
      candidateEnd: candidateRangeMax || '',
      driveStatus: driveStatusValue[0] || '',
      status: jdValue[0] || '',
    })
    setIsMenuOpen(false)
  }
  const onCancelFilter = open => {
    setIsMenuOpen(!isMenuOpen)
    if (!open) {
      setLocationValue([collegesFilterData?.location])
      setCollegeRankValue({
        start: collegesFilterData?.rankingStart,
        end: collegesFilterData?.rankingEnd,
      })
      setCollegeTierValue([collegesFilterData?.tiers])
      setCandidateRangeMin(collegesFilterData?.candidateStart)
      setCandidateRangeMax(collegesFilterData?.candidateEnd)
      setDriveStatusValue([collegesFilterData?.driveStatus])
      setJDValue([collegesFilterData?.status])
    }
  }

  const menu = (
    <MenuFlex column>
      <StyledTab
        border={true}
        tabPosition={'left'}
        type="card"
        padding="15px"
        items={[
          {
            label: 'Location',
            key: '1',
            children: (
              <LocationFilter
                locationValue={locationValue}
                setLocationValue={setLocationValue}
                singleRoleData={cityData || []}
                loadMore={loadMore}
                setLocationSearch={setLocationSearch}
                locationSearch={locationSearch}
              />
            ),
          },

          {
            label: 'College Tier',
            key: '3',
            children: (
              <CollegeTierFilter
                collegeTierValue={collegeTierValue}
                setCollegeTierValue={setCollegeTierValue}
              />
            ),
          },
          {
            label: 'Drive Status',
            key: '4',
            children: (
              <DriveStatusFilter
                driveStatusValue={driveStatusValue}
                setDriveStatusValue={setDriveStatusValue}
              />
            ),
          },
          {
            label: 'Candidate Range',
            key: '5',
            children: (
              <CandidateRangeFilter
                candidateRangeMin={candidateRangeMin}
                setCandidateRangeMin={setCandidateRangeMin}
                candidateRangeMax={candidateRangeMax}
                setCandidateRangeMax={setCandidateRangeMax}
              />
            ),
          },
          {
            label: 'JD Status',
            key: '6',
            children: <JDFilter jdValue={jdValue} setJDValue={setJDValue} />,
          },
        ]}
      />
      <SubmitFlex right>
        <Button.Secondary text="Cancel" onClick={() => onCancelFilter(false)} />
        <Button.Primary text="Apply Filter" onClick={submitFilter} />
      </SubmitFlex>
    </MenuFlex>
  )

  return (
    <TableSearchFilter
      menu={menu}
      open={isMenuOpen}
      setOpen={setIsMenuOpen}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
      totalCount={appliedCollegesList?.count}
      onOpenChange={onCancelFilter}
      currentCount={
        appliedCollegesList?.count < 10
          ? appliedCollegesList?.count
          : appliedCollegesList?.result?.length + appliedCollegesList?.page * 10
      }
    />
  )
}

export default CollegeFilter
